module.exports = __webpack_public_path__ + "static/25-b994beb83339587b698357bd2fa24c7b.png";